import $ from 'jquery';
import  './jquery.vmap.js';

export default class {
    constructor(el) {
        this.el = el
        this.settings = {}
        this.selector = {
            link: '[data-tab-link]',
            linkMobile: '[data-tab-link-mobile]',
            dropdown: '[ data-tab-dropdown]',
            item: '[data-tab-item]',
            tabShow: '[data-tab-show]',
            result: '[data-result-wrapper]',
        }
        this.init()
    }
    init() {
        this.$elem = {
            link: this.el.find(this.selector.link),
            linkMobile: this.el.find(this.selector.linkMobile),
            dropdown: this.el.find(this.selector.dropdown),
            item: this.el.find(this.selector.item),
            tabShow: $(this.selector.tabShow),
            result: $(this.selector.result),
        }
        this.bind()
        this.checkRoute()
    }
    bind() {
        this.el.on({
            'click': (e) => {
                e.preventDefault();
                const elem = $(e.currentTarget)
                if($(window).width()>768) {
                    const id = elem.attr('href');
                    this.$elem.link.removeClass('active')
                    elem.addClass('active')
                    this.show(id);
                    if( $('[data-state-map]').hasClass('map-init'))
                        $('[data-state-map]').vectorMap('deselect');
                } else {
                    this.$elem.dropdown.toggleClass('show')
                }
            }
        }, this.selector.link)
        this.el.on({
            'click': (e) => {
                e.preventDefault();

                    const elem = $(e.currentTarget)

                    const id = elem.attr('href') ,
                    links = this.$elem.link.filter('[href="'+id+'"]')

                    this.$elem.link.removeClass('active')
                    links.addClass('active')
                    this.show(id)

                this.$elem.dropdown.toggleClass('show')
            }
        }, this.selector.linkMobile)
        if($(window).width()<768) {
            $('body').on({
                'click': (e) => {
                    const elem = $(e.target)
                    if (this.$elem.dropdown.hasClass('show') && (!elem.closest(this.selector.dropdown).length && !elem.closest(this.selector.link).length)) {
                        this.$elem.dropdown.toggleClass('show')
                    }
                }
            }, '[search-loan]')
        }
    }
    show(id) {
        const currentItem = this.$elem.item.filter('[data-id="'+id+'"]')
        this.$elem.item.removeClass('active')
        currentItem.addClass('active')
        this.$elem.tabShow.removeClass('active')
        this.$elem.tabShow.filter('[data-show-tabs="'+id+'"]').addClass('active')
        location.hash = id
        this.$elem.result.addClass('d-none')
    }
    open(hash) {
        const elem = this.$elem.link.filter('[href="'+hash+'"]')
        const id = hash;
        this.$elem.link.removeClass('active')
        elem.addClass('active')
        this.show(id)
        this.$elem.result.addClass('d-none')
    }
    checkRoute() {
        const hash = location.hash

        if(hash.length && this.$elem.link.filter('[href="'+hash+'"]').length) {
            this.open(hash)
        } else {
            this.$elem.link.first().trigger('click')
        }
    }
}